import cn from 'classnames';

import { useCheckoutContext, Article } from '@zooplus/checkout-state';
import { P1 } from '@zooplus/ui-components';

import styles from '../cart-item.module.scss';
import ItemStandardPrice from '../item-standard-price';

import { CART_ITEM_IMAGE_DIMENSION, CHECKOUT_STATE_PROJECT_ID } from '@utilities/constants';
import { showFallbackImage } from '@utilities/fallback-image';
import { trimLeadingHyphenAndSpaces } from '@utilities/utils';

const FreeItem = ({ name, pictureUrl, variantName, formattedSubtotal }: Article) => {
  const { mainTogglesMap = {} } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);
  const { WIDTH, HEIGHT } = CART_ITEM_IMAGE_DIMENSION;

  const isNewPricingEnabled = mainTogglesMap.NEW_PRICING_COMPONENT_IN_CART_AND_PREVIEW;

  return (
    <article className={cn(styles.productInfoWrapper, styles.typeFreeOrSPArticle)}>
      <section className={styles.productImgWrapper}>
        <img
          loading="lazy"
          src={pictureUrl}
          alt={name}
          onError={(e) =>
            showFallbackImage(e, {
              width: WIDTH,
              height: HEIGHT,
            })
          }
          width={WIDTH}
          height={HEIGHT}
        />
      </section>
      <section data-testid="product-info" className={styles.productNameWrapper}>
        <P1 bold data-testid="product-name">
          {name}
        </P1>
        <P1 data-testid="product-variant" className={styles.productVariantName}>
          {trimLeadingHyphenAndSpaces(variantName)}
        </P1>
      </section>
      <section className={styles.articleFreePrice}>
        <ItemStandardPrice
          formattedSubtotal={formattedSubtotal}
          isNewPricingEnabled={isNewPricingEnabled}
        />
      </section>
    </article>
  );
};

export default FreeItem;
